export const summaryJobProfileEmptyState = {
	id: '',
	name: '',
	description: '',
	type: '',
	employeesCount: 0,
	jobRisks: [
		{
			id: '',
			name: '',
			imageUrl: '',
			jobRiskFactors: [
				{
					id: '',
					jobProfileRiskFactorId: '',
					name: '',
					exposureLevel: '',
					exposureFrequency: '',

					exams: [
						{
							id: '',
							name: '',
							type: [''],
							frequency: [''],
							images: [
								{
									name: '',
									url: '',
								},
							],
						},
					],
				},
			],
		},
	],
	recommendedExams: [
		{
			id: '',
			name: '',
			type: [''],
			frequency: [''],
			images: [
				{
					name: '',
					url: '',
				},
			],
		},
	],
};
